import { Typography } from '@mui/material'
import { renderInline } from './renderInline'
import { renderTextBlockList } from './renderTextBlockList'

/**
 * The pre-Stage-2 parser, extracted unchanged from `Phase1MessageContent` so it
 * can be selected by `VITE_MARKDOWN_RENDERER`.
 *
 * Retains all four known defects on purpose — it is the flag-off path, and its
 * job is to behave exactly as before, not to be half-fixed. The corrected
 * behaviour lives in `MarkdownRenderer`.
 */
const headingSx = (level) => ({
  fontFamily: 'var(--app-font-display)',
  fontWeight: 700,
  fontSize: level === 1 ? 18 : level === 2 ? 16 : 15,
  lineHeight: 1.35,
  mt: 1,
  mb: 0.5,
})

export function renderTextBlock(block, citations, key) {
  const lines = block.split('\n')

  const list = renderTextBlockList(lines, citations, key)
  if (list) return list

  // No `m` flag, so this only matches when the heading is the whole block —
  // defect 1.
  const heading = block.match(/^(#{1,3})\s+(.*)$/)
  if (heading) {
    return (
      <Typography key={key} component="h3" sx={headingSx(heading[1].length)}>
        {renderInline(heading[2], citations, `${key}-h`)}
      </Typography>
    )
  }

  return (
    <Typography key={key} component="p" sx={{ m: 0, font: 'inherit', whiteSpace: 'pre-wrap' }}>
      {lines.map((line, index) => (
        <span key={index}>
          {index > 0 ? <br /> : null}
          {renderInline(line, citations, `${key}-line-${index}`)}
        </span>
      ))}
    </Typography>
  )
}
